import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { GlobalFlagsService } from '../../services/global-flags.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private router: Router,
    private globalFlags: GlobalFlagsService
  ) { }

  notFound: boolean = null;
  error: any = null;

  ngOnInit() {
    this.globalFlags.error.subscribe((val: boolean) => {
      this.error = val;
    });
    if (this.error.status === 404) {
      this.notFound = true;
    } else {
      this.notFound = false;
    }
  }

}
